class SettlementTable {
    constructor(toastr, moment, SettlementServiceApi, TraceHubExService, DownloadXmlExService, SettlementFilesService, SettingsService) {
        this.$onInit = () => {
            this.SettingsService.getSettings().then((response) => {
                const appSettings = response.data;
                // Signalr block
                // NOTE: SignalR Methods
                this.hub.connectWithSpecificTransport('settlement-table', appSettings.SignalRTransport);
                this.hub.on('settlement-table', 'onInit', (connId) => {
                    this.connectionId = connId;
                });
                this.hub.on('settlement-table', 'onNewFiles', (settlementDto) => {
                    if (settlementDto.ConnectionId !== this.connectionId) {
                        return;
                    }
                    let testerId = this.testerId;
                    this.files = this.SettlementFilesService.filterForTester(testerId, settlementDto.Files);
                });
                // End SignalR block
            });
        };
        this.$onChanges = (changes) => {
            if (changes.testerId) {
                let testerId = changes.testerId.currentValue;
                if (testerId === undefined) {
                    return;
                }
                this.renderTesterFiles(testerId);
            }
            if (changes.fileId) {
                let fileId = changes.fileId.currentValue;
                if (!fileId) {
                    return;
                }
                this.selectedFileId = fileId;
            }
        };
        this.selectFile = (fileId) => {
            this.selectedFileId = fileId;
            this.onSelect({ fileId: fileId });
        };
        this.getPopoverHTML = (file) => '<table class="table-striped"><tr><td><b>Id&nbsp;</td><td>' + file.Id
            + '</td></tr><tr><td><b>Source Simulator&nbsp;</b></td><td>' + file.SourceSimName
            + '</td></tr><tr><td><b>Settlement Simulator&nbsp;</b></td><td>' + file.SettlementSimName
            + '</td></tr><tr><td><b>Date From&nbsp;</b></td><td>' + this.moment(file.DateFm).format('YYYY-DD-MM:HH-mm-ss')
            + '</td></tr><tr><td><b>Date To&nbsp;</b></td><td>' + this.moment(file.DateTo).format('YYYY-DD-MM:HH-mm-ss')
            + '</td></tr><tr><td><b>File Name&nbsp;</b></td><td>' + file.SettlementFileName
            + '</td></tr></table>';
        this.getSettlementFileRowDescription = (rec) => {
            let monentStr = this.timeAgo(rec);
            let description = rec.SettlementSimName;
            if (rec.SettlementFileName !== '') {
                return description + ': ' + rec.SettlementFileName + ' ' + monentStr;
            }
            return (description +
                ' from ' +
                this.moment(rec.DateFm).format('YYYY-DD-MM') +
                ' to ' +
                this.moment(rec.DateTo).format('YYYY-DD-MM') +
                ' : Created ' +
                monentStr);
        };
        this.renderTesterFiles = (testerId) => {
            this.SettlementServiceApi.testerSettlementFiles(testerId).then(response => {
                let files = response.data;
                this.files = files;
                this.testerId = testerId;
                this.selectedFileId = files[0].Id;
            });
        };
        this.timeAgo = (file) => {
            // local timezone conversion already done server side
            const local = this.moment(file.Created);
            return this.moment(local).fromNow();
        };
        this.downloadSettlementFile = (id) => {
            this.DownloadXmlExService.downloadSettlementFile(id);
        };
        this.resubmit = (id) => {
            this.SettlementServiceApi.processTraces(id).then(response => {
                let result = response.data;
                if (!result) {
                    this.toastr.error('Resubmit submission failed');
                }
            });
        };
        this.$onDestroy = () => {
            this.hub.stop('settlement-table');
        };
        this.toastr = toastr;
        this.moment = moment;
        this.SettlementServiceApi = SettlementServiceApi;
        this.SettlementFilesService = SettlementFilesService;
        this.DownloadXmlExService = DownloadXmlExService;
        this.hub = TraceHubExService;
        this.SettingsService = SettingsService;
    }
}
angular.module('app').component('settlementTable', {
    bindings: {
        testerId: '<',
        fileId: '<',
        // TODO: See if we need the other stuff
        settlementFiles: '<',
        onSelect: '&'
    },
    controllerAs: 'vm',
    controller: SettlementTable,
    templateUrl: 'scripts/app/partials/settlement/settlement-table.tpl.html'
});
